<template>
  <v-data-table
    :items="data.products"
    :headers="headersWithAction"
    :rows-per-page-items="rowsPerPageItems"
    :pagination.sync="pagination"
    :no-data-text="'Please add products'"
  >
    <template v-slot:items="{ item }">
      <tr>
        <td class="text-xs-center no-wrap">
          {{ item.name }}
        </td>
        <td class="text-xs-center no-wrap">
          <v-edit-dialog
            :return-value.sync="item.temperature"
            large
            lazy
            persistent
            v-if="edit"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn flat small color="success" v-on="on">
                  <template v-if="!item.temperature">
                    <v-icon small>edit</v-icon>
                  </template>
                  <template>
                    {{ item.temperature }}
                  </template>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <template v-slot:input>
              <v-text-field
                type="number"
                min="0"
                v-model="item.temperature"
                label="Temperature"
                name="temperature"
              />
            </template>
          </v-edit-dialog>
          <template v-else>
            {{ item.temperature }}
          </template>
        </td>
        <td class="text-xs-center" v-if="edit">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                color="error"
                v-on="on"
                @click="remove(item.id)"
              >
                close
              </v-icon>
            </template>
            <span>Remove</span>
          </v-tooltip>
        </td>
      </tr>
    </template>

    <template v-slot:actions-append>
      <template v-if="edit">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              small
              color="success"
              :disabled="isResetProducts || isSendingProducts"
              v-on="on"
              @click="showNewProductsPopup"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>New product</span>
        </v-tooltip>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import AnalysisObject from '@/orm/models/AnalysisObject';
import AnalysisProducts from '@/orm/models/AnalysisProducts';

export default {
  name: 'products',
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    newProductsPopupStatus: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Product',
          value: 'name',
          align: 'center',
          class: 'text-uppercase',
          sortable: true,
        },
        {
          text: 'Температура хранения',
          value: 'temperature',
          align: 'center',
          class: 'text-uppercase',
          sortable: false,
        },
      ],
      data: {
        products: [],
      },
      rowsPerPageItems: [
        3,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        rowsPerPage: -1,
      },
      isSendingProducts: false,
      isResetProducts: false,
    };
  },
  watch: {
    products: {
      immediate: true,
      handler(data) {
        this.data.products = JSON.parse(JSON.stringify(data));
      },
    },
  },
  computed: {
    headersWithAction() {
      if (this.edit) {
        return [
          ...this.headers,
          {
            text: 'Actions',
            value: 'id',
            align: 'center',
            class: 'text-uppercase',
            sortable: false,
          },
        ];
      }
      return this.headers;
    },
  },
  methods: {
    showNewProductsPopup() {
      this.$emit('update:newProductsPopupStatus', true);
    },
    remove(id) {
      const i = this.data.products.findIndex(p => p.id === id);
      this.data.products.splice(i, 1);
    },
    async resetProducts() {
      try {
        this.isResetProducts = true;
        const { params } = this.$route;
        const { products } = await AnalysisObject.$get({ params });
        await AnalysisProducts.create({ data: products.items || [] });
      } finally {
        this.isResetProducts = false;
        this.$emit('update:edit', false);
      }
    },
    async saveProducts() {
      try {
        this.isSendingProducts = true;
        const { params } = this.$route;
        const { products } = await AnalysisObject.$update({
          params,
          data: {
            products: {
              items: this.data.products,
            },
          },
        });
        console.log(products);
        await AnalysisProducts.create({ data: products.items || [] });
      } finally {
        this.isSendingProducts = false;
      }
    },
    editProducts() {
      this.$emit('update:edit', true);
    },
  },
  components: {
    datePicker: () => import('@/components/form/datePicker'),
  },
};
</script>
